import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { Box, Typography } from '@mui/material'
import { Banner, BannerType } from '@finanzcheck/teal-components'
import { useStores } from 'stores/utils/hooks/useStores'
import { PrefillErrorKind } from 'stores/PrefillStore'
import { trackDobCheck, trackPinCheck } from './utils'
import { trackInAmplitude } from 'utils/tracking/amplitude'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'

const PREFILL_ERROR_TEXTS = {
  [PrefillErrorKind.TECHNICAL]: {
    banner: 'Leider ist ein Fehler aufgetreten.',
    body: 'Derzeit haben wir Probleme mit dieser Funktion. Bitte machen Sie stattdessen mit der manuellen Eingabe weiter.'
  },
  [PrefillErrorKind.MAX_ATTEMPTS]: {
    banner:
      'Die maximale Anzahl an Versuchen wurde erreicht. Bitte fahren Sie manuell fort.',
    body: 'Zu Ihrer Sicherheit und zum Schutz der Daten unserer Kunden bitten wir Sie, die restlichen Daten manuell einzugeben.'
  }
} as const

const Error: React.FC = observer(() => {
  const {
    prefill: { pin, errorKind, dob },
    navigation: { currentPageInSession },
    traversal: {
      data: {
        debtors: {
          primary: {
            personal: { firstname, lastname }
          }
        }
      }
    }
  } = useStores()

  const copy = PREFILL_ERROR_TEXTS[errorKind]

  useEffect(() => {
    if (currentPageInSession === 'authenticatePin') {
      trackPinCheck('failure')
    }
    if (currentPageInSession === 'authenticateDob') {
      trackDobCheck('failure')
    }
  }, [currentPageInSession])

  useEffect(() => {
    trackInAmplitude(AmplitudeEvent.PrefillErrorPageRendered, {
      errorKind,
      hasPin: !!pin,
      hasDob: !!dob
    })
  }, [errorKind, pin, dob])

  return (
    <div>
      <Box marginBottom={2} marginTop={2}>
        <Banner
          type={BannerType.ERROR}
          desc={copy.banner}
          isIconVersionOutline
        />
      </Box>
      <Typography variant="h3" color="primary" textAlign="center" mb={2}>
        {`Willkommen zurück ${firstname} ${lastname}!`}
      </Typography>
      <Typography variant="body1" paragraph>
        {copy.body}
      </Typography>
    </div>
  )
})

export { Error }
